import React, { useState } from "react";
import { send } from "emailjs-com";
import styles from "./emailForm.module.scss";

export default function EmailForm() {
  const [toSend, setToSend] = useState({
    from_name: "",
    to_name: "Rapolas",
    message: "",
    reply_to: "",
  });

  const handleSendAnotherEmail = () => {
    setEmailSent(false);
    sethovered(false);
    toSend.from_name = "";
    toSend.message = "";
    toSend.reply_to = "";
  };

  // On Button click checking if values are not empty and sending the email
  const onSubmit = (e) => {
    setloading(true);
    e.preventDefault();
    toSend.from_name.trim().length !== 0 ||
    toSend.message.trim().length !== 0 ||
    toSend.reply_to.trim().length !== 0
      ? send("service_m85cpiq", "template_cggtdlg", toSend, "E3an9ddIoJ7QxdhvC")
          .then((response) => {
            setloading(false);
            setEmailSent(true);
            //console.log("SUCCESS!", response.status, response.text);
          })
          .catch((err) => {
            setloading(false);
            console.log("FAILED...", err);
          })
      : console.log("Please enter the required values");
  };

  // input validation, checking if values are not empty
  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
    if (
      toSend.from_name.length === 0 ||
      toSend.message.length === 0 ||
      toSend.reply_to.length === 0
    ) {
    }
    if (toSend.reply_to.includes("@")) {
      setIsShown("");
    }
  };

  const [isShown, setIsShown] = useState("submitButtonInFormCenter");
  const [loading, setloading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [hovered, sethovered] = useState(false);

  var validEmailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  const onHover = (e) => {
    e.preventDefault();
    sethovered(true);
    if (
      toSend.from_name.length === 0 ||
      toSend.message.length === 0 ||
      !toSend.reply_to.match(validEmailRegex)
    ) {
      isShown === "submitButtonInFormStart"
        ? setIsShown("submitButtonInFormEnd")
        : setIsShown("submitButtonInFormStart");
    } else {
    }
  };
  return emailSent ? (
    <div className={styles.emailSent}>
      Thank you for your email!
      <br /> I'll reply as soon as possible!
      <button
        onClick={() => handleSendAnotherEmail()}
        className={styles.anotherEmail}
      >
        Send another email
      </button>
    </div>
  ) : (
    <form onSubmit={onSubmit} id="emailForm" className={styles.formContainer}>
      <div className={styles.emailForm}>
        <div className={styles.emailFormTitle}>Any ideas to share?</div>

        <div className={styles.nameAndEmail}>
          <div className={styles.inputBox}>
            <input
              type="text"
              placeholder=" "
              name="from_name"
              value={toSend.from_name}
              onChange={handleChange}
              required
              className={`${styles.nameInput} ${
                hovered ? styles.hoveredNameInput : ""
              }`}
            />
            <span>name</span>
          </div>
          <div className={styles.inputBox}>
            <input
              type="email"
              name="reply_to"
              placeholder=" "
              value={toSend.reply_to}
              onChange={handleChange}
              className={` ${styles.emailInput} ${
                hovered ? styles.hoveredEmailInput : ""
              }`}
              required
            />
            <span>Email</span>
          </div>
        </div>
        <textarea
          name="message"
          placeholder="Your message"
          value={toSend.message}
          onChange={handleChange}
          required
          className={`${styles.messageInput} ${
            hovered ? styles.hoveredMessageInput : ""
          }`}
        />
        <div className={styles.buttonContainer}>
          <button
            type="submit"
            onMouseEnter={onHover}
            className={`${loading ? styles.buttonload : styles.submitButton}  ${
              hovered
                ? `${styles.hoveredButton} ${styles[isShown]}`
                : styles.submitButton
            }`}
          >
            <span className={styles.button__text}>Submit</span>
          </button>
        </div>
      </div>
    </form>
  );
}
